export const HERO_CONSTANTS = {
  button: {
    label: "Choose the best testing approach for your needs",
    link: "#contact-us",
  },
  title: "Real-World IT Testing: Emulation vs. Simulation",
};
